import React from "react";
import { Row, Col, Typography, Button } from "antd";
import EmptyStateSvg from "./EmptyState.svg";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";
const { Title, Text } = Typography;
export default function EmptyState({history,collectionId}) {
  return (
    <Row justify="center" style={{ marginTop: "5em" }}>
      <Col>
        <Row justify="center" style={{ marginTop: "1em" }}>
          <Col>
            <img src={EmptyStateSvg} width="100%" alt="empty" />
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: "1em" }}>
          <Col>
            {" "}
            <Title level={2}>No products added to catalogue</Title>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: "1em" }}>
          <Col>
            {" "}
            <Text>Start adding products to generate a catalogue</Text>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: "1em" }}>
          <Col>
            <Button
              style={{
                color: "white",
                backgroundColor: "black",
                width: 148,
                height: 48,
                border: 0,
              }}
              size="large"
              onClick={() => {
                history.push({
                  pathname: `/select-products/${collectionId}`,
                  state: {
                    type: "edit",
                  },
                })
                gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.VIEW_COLLECTION_ADD_PRODUCT_BUTTON);
              }}
            >
              Add products
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
